(function () {
  'use strict';

  // Forces "Quick view" for every Searchanise product card.
  //
  // Searchanise renders single-variant products with an "Add to cart" button and
  // multi-variant products with a "Quick view" button. This script watches the
  // Searchanise results container (or document.body if not yet rendered) and:
  //   1. Finds any button/link inside a .snize-product card whose text is "Add to cart"
  //      OR whose class contains known Searchanise add-to-cart patterns.
  //   2. Hides it and inserts a Quick View link in its place.
  //      The new link uses the same class as existing Quick View buttons on the page
  //      so Searchanise's own click handler opens its modal identically.

  var ATC_TEXT_RE = /add\s+to\s+cart/i;

  // Selectors we know Searchanise uses for its add-to-cart buttons.
  // Listed broadly so this works regardless of minor class-name version differences.
  var ATC_SELECTORS = [
    '.snize-add-to-cart',
    '.snize-add-to-cart-button',
    '.snize-button.snize-add-to-cart',
    'button[class*="snize"][class*="cart"]',
    'button[class*="snize"][class*="add"]',
    'a[class*="snize"][class*="cart"]',
    'a[class*="snize"][class*="add"]',
  ].join(',');

  // Selector for Searchanise's Quick View button — used to clone its class list.
  var QV_SELECTORS = [
    '.snize-view-product',
    '.snize-quickview',
    '.snize-quick-view',
    'a[class*="snize"][class*="view"]',
    'a[class*="snize"][class*="quick"]',
  ].join(',');

  function getQVClassName() {
    var el = document.querySelector('#snize_results ' + QV_SELECTORS);
    return el ? el.className : 'snize-view-product';
  }

  function transformCard(card) {
    if (card.getAttribute('data-qv-done')) return;

    // Match by known selector
    var atcBtn = card.querySelector(ATC_SELECTORS);

    // Fallback: match any button/link whose visible text says "Add to cart"
    if (!atcBtn) {
      card.querySelectorAll('button, a').forEach(function (el) {
        if (!atcBtn && ATC_TEXT_RE.test(el.textContent)) atcBtn = el;
      });
    }

    if (!atcBtn) return;

    // Don't double-process
    if (atcBtn.getAttribute('data-qv-transformed')) return;
    atcBtn.setAttribute('data-qv-transformed', '1');
    card.setAttribute('data-qv-done', '1');

    // Resolve product URL from the card
    var productLink =
      card.querySelector('a[class*="snize"][href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    var qvBtn = document.createElement('a');
    qvBtn.href = productLink.href;
    qvBtn.setAttribute('data-qv-override', '1');
    qvBtn.className = getQVClassName();
    qvBtn.textContent = 'Quick view';

    atcBtn.parentNode.insertBefore(qvBtn, atcBtn);
    atcBtn.style.display = 'none';
  }

  function transformAll(root) {
    (root || document).querySelectorAll('.snize-product').forEach(transformCard);
  }

  function startObserver(target) {
    var observer = new MutationObserver(function () {
      transformAll(target);
    });
    observer.observe(target, { childList: true, subtree: true });
    // Run immediately on whatever is already rendered
    transformAll(target);
  }

  function init() {
    var resultsEl = document.getElementById('snize_results');

    if (resultsEl) {
      startObserver(resultsEl);
    } else {
      // #snize_results not yet in DOM — watch body until it appears, then switch
      var bodyObserver = new MutationObserver(function () {
        var el = document.getElementById('snize_results');
        if (el) {
          bodyObserver.disconnect();
          startObserver(el);
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
